import { isNil } from 'lodash'
import { type Page, toListQuery } from '@hello-aria/makalu-api-client'
import type { OnboardingGateway } from '@/shared/models/onboardingModels'
import { makaluApi } from '@/shared/utils/makaluApiClient'

import type { QueryStringInput } from '@hello-aria/query-string'

export type ListOnboardings = {
    companyId: string | undefined
    query?: QueryStringInput
}

export const listOnboardings = async (params: ListOnboardings): Promise<Page<OnboardingGateway> | undefined> => {
    const { query, companyId } = params

    if (isNil(companyId)) return

    return makaluApi.listPage('/companies/{companyId}/onboardings', {
        params: { path: { companyId }, query: toListQuery(query ?? {}) }
    })
}

export const getOnboarding = async (
    companyId: string,
    onboardingId: string | undefined
): Promise<OnboardingGateway | undefined> => {
    if (isNil(onboardingId)) return

    return makaluApi.GET('/companies/{companyId}/onboardings/{onboardingId}', {
        params: { path: { companyId, onboardingId } }
    })
}
